module.exports = __webpack_public_path__ + "images/emoji/mailbox_closed.243a0df801e78ce4dccf.png";